/**
 * Map een partner-union subtype naar de lijn-styling-waarde op een spousal
 * LayoutLink. 'marriage' en alle onbekende/undefined types → undefined zodat
 * de renderer een kale (solide) spousal-lijn tekent.
 *
 * Gespiegeld aan `resolvePediType` (parent-child variant) — zelfde stijl en
 * return-undefined-for-default conventie. Exacte string-waarden worden door
 * `getSpousalDash` (treePdfLinks.ts) en door de web-tree CSS geconsumeerd.
 */
export function resolvePartnerLineType(
  rel: string | undefined
): 'partnership' | 'engagement' | undefined {
  switch (rel) {
    case 'partnership':
      return 'partnership';
    case 'engagement':
      return 'engagement';
    default:
      return undefined; // marriage / undefined / onbekend → solide lijn
  }
}
